import logo from 'assets/images/logo.png';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse }: { reverse?: boolean }) => {
  return <img src={logo} alt="DrizzleX" width="150" />;
};

export default LogoMain;
